import { FC, useCallback } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography, Svg, Button, useThemeValue } from '@altermaind/web/ui';
import { convertSizeToNumber } from '@/_shared/helpers';
import { useDialog, usePlatform } from '@/_shared/hooks';

type Props = {
  onClose: () => void;
  onCancel?: () => void;
};

export const DialogConfirmExitFromDocument: FC<Props> = ({ onClose, onCancel }) => {
  const t = useTranslations('documents.confirmExitFromDocumentDialog');
  const { closeDialog, Dialog, isOpen } = useDialog('confirmExitFromDocumentDialog');
  const gapL = convertSizeToNumber(`${useThemeValue('sizes', 'l')}`);
  const { isAdmin } = usePlatform();

  const onExitCanceled = useCallback(() => {
    closeDialog();
    onCancel?.();
  }, [closeDialog, onCancel]);

  const onExitConfirm = useCallback(() => {
    closeDialog();
    onClose();
  }, [closeDialog, onClose]);

  return (
    <Dialog maxWidth='700px' open={isOpen} title={undefined} onClose={closeDialog} closeButton>
      <Box display='flex' mb='m' flexDirection='column' px='s'>
        <Svg name='info' size='xxl' />
      </Box>
      <Box display='flex' mx='l' flexDirection='column' px='s'>
        <Typography variant='h3' color='primary/text' textAlign='center'>
          {t('title')}
        </Typography>
      </Box>
      <Box display='flex' mt='s' flexDirection='column' px='s'>
        <Typography variant='p2/light' color='primary/text' textAlign='center'>
          {t(isAdmin ? 'adminDescription' : 'description')}
        </Typography>
      </Box>

      <Box
        display='flex'
        mx='l'
        flexDirection='row'
        px='s'
        style={{ gap: gapL }}
        justifyContent='center'
      >
        <Button
          variant='link/primary'
          onClick={onExitCanceled}
          mt='l'
          style={{ textDecoration: 'none' }}
        >
          <Svg name='close' fill='primary/text' size='s' mr='xs' />
          {t('cancel')}
        </Button>

        <Button variant='primary' onClick={onExitConfirm} mt='l'>
          {t('confirm')}
        </Button>
      </Box>
    </Dialog>
  );
};
